var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.checkWidth() + ' ' + 'container'},[(_vm.loading)?[_c('div',{staticClass:"container vertical-center"},[_c('LoadingMDL')],1)]:[_c('ContentSelect',{attrs:{"cardContent":_vm.dataContent,"commitPayloadData":_vm.commitPayloadData,"funcUpdateProgress":_vm.updateProgress}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }